import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/globalcss/style.css";
import "@/assets/globalcss/style.css";
import "@/assets/globalcss/typography.css";
import "@/assets/globalcss/GlobalStyle.css";
import { Datetime } from "vue-datetime";
import Vuelidate from "vuelidate";
import "./permission.js"; // permission control
import "../src/assets/globalcss/style.css";
import "../src/assets/globalcss/GlobalStyle.css";
import "vue-datetime/dist/vue-datetime.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueGoogleApi from "vue-google-api";
import "vue-popperjs/dist/vue-popper.css";

const config = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
};
// Ensure that VueGoogleApi is correctly imported and used
Vue.use(VueGoogleApi, config);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(Datetime);
Vue.use(DatePicker);
Vue.component("datetime", Datetime);

function filterControlCharacters(value) {
  return value
    .split("")
    .filter((char) => char.charCodeAt(0) >= 32 || char.charCodeAt(0) === 9)
    .join("");
}

function safeHTML(htmlString) {
  let doc = document.implementation.createHTMLDocument("");
  let div = doc.createElement("div");
  div.innerHTML = htmlString;

  for (
    let elements = div.querySelectorAll("*"), i = elements.length - 1;
    i >= 0;
    i--
  ) {
    let element = elements[i],
      tagName = element.localName;

    if (
      tagName == "script" ||
      tagName == "noscript" ||
      tagName == "noembed" ||
      !(element.attributes instanceof NamedNodeMap)
    ) {
      try {
        element.parentNode.removeChild(element);
      } catch (e) {
        element.outerHTML = "";
      }
      continue;
    }

    if (!element.hasAttributes()) continue;

    for (
      let attributes = element.attributes, j = attributes.length - 1;
      j >= 0;
      j--
    ) {
      let attribute = attributes[j],
        attributeName = attribute.localName,
        attributeValue = filterControlCharacters(attribute.value.trim());
      handleAttribute(element, attributeName, attributeValue);
    }
  }

  return div.innerHTML;
}

function handleAttribute(element, attributeName, attributeValue, tagName) {
  if (
    attributeName.startsWith("on") ||
    (["src", "href"].includes(attributeName) &&
      attributeValue.indexOf("javascript:") === 0) ||
    (["audio", "image", "img", "source", "video"].indexOf(tagName) === -1 &&
      ["src", "data"].includes(attributeName) &&
      attributeValue.indexOf("data:") === 0)
  ) {
    element.removeAttribute(attributeName);
  }
}

Vue.directive("html-safe", {
  // For Vue 2.x
  inserted: function (el, binding) {
    el.innerHTML = safeHTML(binding.value);
  },
  // For Vue 2.x
  update: function (el, binding) {
    if (binding.value !== binding.oldValue)
      el.innerHTML = safeHTML(binding.value);
  },
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
Vue.filter("kanbanmailid", function (value) {
  if (value.length <= 15) {
    return value;
  } else {
    return value.slice(0, 14) + "...";
  }
});
Vue.filter("accesscontroluser", function (value) {
  if (value.length <= 32) {
    return value;
  } else {
    return value.slice(0, 31) + "...";
  }
});
Vue.filter("vendorName", function (value) {
  if (value.length <= 25) {
    return value;
  } else {
    return value.slice(0, 24) + "...";
  }
});
Vue.filter("accesscontLandingPage", function (value) {
  if (value.length <= 25) {
    return value;
  } else {
    return value.slice(0, 24) + "...";
  }
});
Vue.filter("fdbckFilter", function (value) {
  if (value.length <= 21) {
    return value;
  } else {
    return value.slice(0, 20) + "...";
  }
});
Vue.filter("cardname", function (value) {
  if (value.length <= 20) {
    return value;
  } else {
    return value.slice(0, 10) + "...";
  }
});
Vue.filter("ipname", function (value) {
  if (value.length <= 27) {
    return value;
  } else {
    return value.slice(0, 26) + "...";
  }
});
Vue.filter("teamsEmail", function (value) {
  if (value.length <= 20) {
    return value;
  } else {
    return value.slice(0, 19) + "...";
  }
});
Vue.filter("accesscontrolroles", function (value) {
  if (value.length <= 50) {
    return value;
  } else {
    return value.slice(0, 49) + "...";
  }
});
Vue.filter("accesscontrolrolesOne", function (value) {
  if (value.length <= 32) {
    return value;
  } else {
    return value.slice(0, 31) + "...";
  }
});
Vue.filter("accesscontrolrolesdesc", function (value) {
  if (value.length <= 65) {
    return value;
  } else {
    return value.slice(0, 64) + "...";
  }
});

// filter for reducing customer name in the internal hiring dashboard
Vue.filter("reduceTheCustermerNameSize", function (value) {
  if (value.length < 52) {
    return value;
  } else {
    return value.slice(0, 52) + "...";
  }
});
// Filter for Questionbank Date created
Vue.filter("datefilter", function (value) {
  return value.substring(0, 10);
});
Vue.filter("formatDate", function (value) {
  if (value) {
    let parts = value.split("-");
    parts = parts.reverse();
    parts = parts.join("-");
    return parts;
  }
});

Vue.directive("closeArray", {
  bind(el, binding) {
    const { index, property, array, handler, exclude } = binding.value;

    const closeHandler = (event) => {
      // Build a selector string for exclusion elements
      const excludeSelector = exclude.map((item) => `.${item}`).join(", ");

      // Check if the click was outside the element and not on excluded elements
      if (
        !el.contains(event.target) &&
        !event.target.closest(excludeSelector)
      ) {
        // Check if the index is valid within the array
        if (index >= 0 && index < array.length) {
          // Toggle the property value for the specified index
          array[index][property] = !array[index][property];
        }

        // Call the handler function with index as a parameter
        handler(index);
      }
    };

    el.__closableClickOutsideHandler = closeHandler;
    document.addEventListener("click", closeHandler);
  },
  unbind(el) {
    document.removeEventListener("click", el.__closableClickOutsideHandler);
    delete el.__closableClickOutsideHandler;
  },
});

Vue.directive("closable", {
  bind(el, binding, vnode) {
    // Per-element handler stored on the node, so unbind removes only this
    // element's listener.
    const handleOutsideClick = (e) => {
      e.stopPropagation();
      // Ignore clicks whose target was removed from the DOM by the click
      // itself; `contains` would report them as outside clicks.
      if (!e.target.isConnected) return;
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value;
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          let excludedEl = vnode.context.$refs[refName];
          excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
          // Get the element using the reference name
          // See if this excluded element
          // is the same element the user just clicked on
          if (excludedEl) {
            // See if this excluded element
            // is the same element the user just clicked on
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      // exclude date range picker
      if (!clickedOnExcludedEl) {
        const popup = document.querySelector(".mx-datepicker-popup");
        if (popup && popup.contains(e.target)) {
          clickedOnExcludedEl = true;
        }
      }
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    el.__closableHandler = handleOutsideClick;
    document.addEventListener("click", handleOutsideClick);
  },

  unbind(el) {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", el.__closableHandler);
    delete el.__closableHandler;
  },
});
